export const OFFICE_HOURS_START_TIME = ['officeHoursStartTime'];